import React, { FC } from 'react';
import { Typography } from '@components/atoms/Typography';
import { Card } from '@components/atoms/Card';
import { RadioButton, RadioButtonProps, RadioButtonType } from '@components/atoms/RadioButton';
import styles from './PaymentMethodCard.module.css';

export interface PaymentMethodCardProps {
    title: string;
    description?: string;
    logo?: string;
    children?: JSX.Element | JSX.Element[];
    radioButton: Pick<RadioButtonProps, 'value' | 'checked' | 'onChange'>;
}

export const PaymentMethodCard: FC<PaymentMethodCardProps> = ({ title, description, logo, children, radioButton }) => {
    return (
        <Card classes={styles['payment-method-card']}>
            <div className="d-flex">
                <div className={styles['radio-container']}>
                    <RadioButton
                        id={`payment-method-${radioButton.value}`}
                        type={RadioButtonType.normal}
                        name="payment-method"
                        value={radioButton.value}
                        checked={radioButton.checked}
                        onChange={radioButton.onChange}
                    />
                </div>
                <div className="flex-grow-1">
                    {
                        <Typography classes={description ? 'my-1' : 'mt-2 pt-1'} fontSize="16" fontWeight="900">
                            {title}
                        </Typography>
                    }
                    {description && (
                        <Typography classes="mb-0" fontSize="14" color="muted">
                            {description}
                        </Typography>
                    )}
                    {children && <div className="mt-3">{children}</div>}
                </div>
                {logo && (
                    <div className={styles['logo-container']}>
                        <img src={logo} alt={title} />
                    </div>
                )}
            </div>
        </Card>
    );
};
